// Module
var code = "<a data-bind=\"attr: { title: $data._tooltip }\" class=\"grid-action-button\"> <span data-bind=\"click: $data.MergeAndSaveForGridRow.bind($data)\" class=\"generate-document-btn\"> <!-- ko with: _icon --> <!-- ko template: {html: $data.GetIconTemplate.bind($data)} --><!-- /ko --> <!-- /ko --> </span> </a>";
// Exports
export default code;